class CollectionGrid extends window.BAOv2.CustomElement {
  setupListeners () {
    this._persistScrollTarget = this.persistScrollTarget.bind(this)

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    // Capture: iOS Safari can skip bubbling from <a> inside the custom element.
    this.listeners.add(document, 'pointerdown', this._persistScrollTarget, true)
    this.listeners.add(document, 'touchstart', this._persistScrollTarget, {
      capture: true,
      passive: true,
    })
    this.listeners.add(document, 'click', this._persistScrollTarget, true)
  }

  persistScrollTarget (event) {
    if (!event.target) return

    const eventTarget = event.target.nodeType === 1 ? event.target : event.target.parentElement

    if (!eventTarget || typeof eventTarget.closest !== 'function') return

    const campaignCard = eventTarget.closest('[data-el="collection-filters.promo-card"]')
    const productCard = eventTarget.closest('[data-product-handle]')

    if (!campaignCard && !productCard) return
    if (!this.contains(campaignCard || productCard)) return

    if (
      productCard &&
      eventTarget.closest('button, form, wishlist-button') &&
      !eventTarget.closest('a[href]')
    ) {
      return
    }

    if (campaignCard) {
      const campaignId = campaignCard.getAttribute('data-promo-id')

      if (!campaignId) return

      sessionStorage.setItem('BAO-PlpClickedCampaign', campaignId)
      sessionStorage.removeItem('BAO-PlpClickedProduct')
      sessionStorage.removeItem('lastClickedProductCard')
      return
    }

    const productHandle = productCard.getAttribute('data-product-handle')

    if (!productHandle) return

    sessionStorage.setItem('BAO-PlpClickedProduct', productHandle)
    sessionStorage.setItem('lastClickedProductCard', productHandle)
    sessionStorage.removeItem('BAO-PlpClickedCampaign')
  }
}

if (!customElements.get('collection-grid')) {
  customElements.define('collection-grid', CollectionGrid)
}
